module.exports = __webpack_public_path__ + "static/media/ship3.e9400291.png";